//Copyright Breast Cancer Index || 2021
//Main Page

import React from 'react';

import {
    Navbar,
    SubFooter,
    Footer,
    BackToTop
} from "../../lib";

import ReactGA from 'react-ga';

const ContactThankYou = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div>
      <Navbar type="blank" />
      
      {/* <!-- TEMP LANDING --> */}
      <header className="page-header photo-grad">
        <div className="container-fluid bgc g3 round">
          <div className="clover-container">
            <div className="copy headline">
              <h1>
                Thank You                                
              </h1>
            </div>          
            <div className="photo-clover">
              <img src="/clover-closed.svg" alt="" className="w-100" />
            </div>
          </div>
          <div className="bg-pattern"></div>
        </div>
      </header>

      {/* <!-- CONTENT AREA --> */}
      <div className="container content-page">
        <div className="row">
          <div className="col-12 pt-5 border-bottom">
            <h2 className="font1 clr c1 py-2">
              Thank you for your submission
            </h2>
            <p>
              Thank you for your recent request for more information about Breast Cancer Index. We've received your request and a member of our Patient Services Team will be in touch with you shortly.
            </p>
            <p>
              We appreciate your patience. In the meantime, if you would like to reach out to us, our phone number and email are listed below.
            </p>
            <h2 className='font1 clr c1 py-2'>To contact our Patient Services Team:</h2>
            <p>7AM PDT - 3:30PM PDT (Pacific time)</p>
            <p>P: (844)319-8111</p>
            <p>E: <a href="mailto:patientservices@biotheranostics.com">patientservices@biotheranostics.com</a></p>
          </div>
        </div>
      </div>

      <BackToTop />

      <SubFooter 
        image=""
        icons={[
          {
            href: "/contact-providers",
            img: "/icon-bubble.svg",
            alt: " Contact Breast Cancer Index",
            text1: "Contact Breast",
            text2: "Cancer Index"
          },{
            href: "/order-test",
            img: "/icon-clipboard.svg",
            alt: " Order Breast Cancer Index",
            text1: "Order Breast",
            text2: "Cancer Index",
            className: "clipboard"
          }
        ]} />
        
      <Footer
        showTopLinks={true} topLinks={[
          { link: "/", label: "For Patients" }
        ]}
        showSecondaryLinks={true} secondaryLinks={[
          { link: "/order-test", label: "Order The Test" },
          { link: "/contact-providers", label: "Contact" }
        ]}
        type='provider'
      />

    </div>
  );
}

export default ContactThankYou;
